/* Product page: variant radios, quantity, upgrade + pairs add-ons, gallery, add to cart, sticky bar + options sheet.
   One state object drives the main buy box and the sheet copy, so both always match. */
(function () {
  "use strict";
  const PT = window.PT || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const money = c => (PT.money ? PT.money(c) : "$" + (c / 100).toFixed(2));
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const CHEV_UP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 15 6-6 6 6"/></svg>';

  const mainRootOf = (wrap, sid) => wrap.querySelector(`[data-buy-root="${sid}"]`) || wrap;
  function init(wrap) {
    const sid = wrap.dataset.pdp;
    const jsonEl = document.querySelector(`[data-product-json="${sid}"]`);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = document.querySelector(`[data-buy-form="${sid}"]`) || $("#m-buy", wrap) || mainRootOf(wrap, sid).closest("form") || wrap;
    const mainRoot = $(`[data-buy-root="${sid}"]`, wrap);
    const mode = wrap.dataset.sticky || "off";
    const startId = Number(($("[data-vid]", form) || {}).value);
    const sel = {
      variant: product.variants.find(v => v.id === startId) || product.variants.find(v => v.available) || product.variants[0],
      qty: 1, up: false, pairs: new Set()
    };
    sel.opts = sel.variant ? sel.variant.options.slice() : [];

    const roots = () => [mainRoot, document.querySelector(`#s-buy [data-buy-root="${sid}"]`)].filter(Boolean);
    const findVariant = opts => product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    const upEl = r => $("[data-up]", r);
    const upPrice = () => { const u = upEl(mainRoot); return sel.up && u ? Number(u.dataset.price) : 0; };
    const pairTotal = () => [...sel.pairs].reduce((a, id) => { const i = $(`[data-pair][value="${id}"]`, mainRoot); return a + (i ? Number(i.dataset.price) : 0); }, 0);
    const total = () => ((sel.variant ? sel.variant.price : 0) + upPrice()) * sel.qty + pairTotal();
    const available = () => !!(sel.variant && sel.variant.available);
    const desc = () => {
      const bits = [];
      if (sel.variant && sel.variant.title !== "Default Title") {
        const yn = new Set($$('input[type="checkbox"][data-opt]', mainRoot).map(i => Number(i.dataset.opt) - 1));
        const parts = sel.variant.options.filter((o, i) => !yn.has(i));
        if (parts.length) bits.push(parts.join(" / "));
        if ([...yn].some(i => sel.variant.options[i] !== $(`input[type="checkbox"][data-opt="${i + 1}"]`, mainRoot).dataset.no)) bits.push("+ add-on");
      }
      if (sel.up) bits.push("+ upgrade");
      if (sel.qty > 1) bits.push("Qty " + sel.qty);
      if (sel.pairs.size) bits.push(`+${sel.pairs.size} add-on${sel.pairs.size > 1 ? "s" : ""}`);
      return bits.join(" · ") || wrap.dataset.sub || "";
    };

    function sync() {
      const v = sel.variant;
      roots().forEach(r => {
        $$("[data-opt]", r).forEach(i => {
          const oi = Number(i.dataset.opt) - 1;
          i.checked = sel.opts[oi] === i.value;
          const test = sel.opts.slice(); test[oi] = i.value;
          const tv = findVariant(test), so = !tv || !tv.available;
          const lab = i.closest(".opt"); lab && lab.classList.toggle("is-so", so);
          const s = lab && $("[data-so]", lab); if (s) s.hidden = !so;
        });
        $$("[data-lbl]", r).forEach(l => { l.textContent = sel.opts[Number(l.dataset.lbl) - 1] || ""; });
        $$('input[type="checkbox"][data-opt]', r).forEach(i => {
          const oi = Number(i.dataset.opt) - 1, y = sel.opts.slice(), n = sel.opts.slice(); y[oi] = i.value; n[oi] = i.dataset.no;
          const yv = findVariant(y), nv = findVariant(n), p = i.closest(".opt") && $("[data-yn-p]", i.closest(".opt"));
          if (p) p.textContent = yv && nv && yv.price > nv.price ? "+" + money(yv.price - nv.price) : "";
        });
        const u = upEl(r); if (u) u.checked = sel.up;
        $$("[data-pair]", r).forEach(i => (i.checked = sel.pairs.has(i.value)));
        $$("[data-qtyv]", r).forEach(q => (q.innerHTML = `<span class="sr-only">Quantity </span>${sel.qty}`));
        $$("[data-atc]", r).forEach(b => {
          b.disabled = !available();
          const lab = $("[data-atc-label]", b);
          if (lab) lab.innerHTML = available() ? `Add to cart · <span data-tot>${money(total())}</span>` : "Sold out";
        });
      });
      $$("[data-unit]").forEach(u => (u.textContent = v ? money(v.price) : ""));
      const was = $("[data-was]", wrap);
      if (was && v) { const show = v.compare_at_price && v.compare_at_price > v.price; was.hidden = !show; if (show) was.textContent = money(v.compare_at_price); }
      const st = $("[data-soldtag]", wrap); if (st) st.hidden = available();
      const vid = $("[data-vid]", form); if (vid && v) vid.value = v.id;
      const qin = $("[data-qin]", form); if (qin) qin.value = sel.qty;
      PT.sticky && PT.sticky._render && PT.sticky.refresh();
    }

    function setVariantFromOpts(announce) {
      const v = findVariant(sel.opts);
      sel.variant = v || null;
      if (v) {
        try { const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(history.state, "", u); } catch (_) {}
        applyGroup(v);
        if (v.featured_media) showMedia(v.featured_media.id);
      }
      sync();
      if (announce) PT.live && PT.live(v ? `${v.title}, ${money(v.price)}${v.available ? "" : ", sold out"}` : "That combination isn't available.");
    }

    /* gallery */
    function showIndex(i) {
      $$(".gal-i", wrap).forEach(g => (g.hidden = Number(g.dataset.galI) !== i));
      $$("[data-gal]", wrap).forEach(b => b.setAttribute("aria-pressed", Number(b.dataset.gal) === i));
      $$(".gal-i video", wrap).forEach(vd => { if (vd.closest(".gal-i").hidden) vd.pause(); });
    }
    /* variant photo groups: show shared photos + the selected variant's group */
    const gal = $(".pdp-gal", wrap), grouped = gal && gal.hasAttribute("data-grouped");
    function applyGroup(v) {
      if (!grouped) return;
      const g = v && v.featured_media ? String(v.featured_media.id) : "all";
      const inGroup = el => g === "all" || el.dataset.group === "all" || el.dataset.group === g;
      $$("[data-gal]", wrap).forEach(b => (b.hidden = !inGroup(b)));
      const th = $(".thumbs", wrap); if (th) th.hidden = $$("[data-gal]:not([hidden])", wrap).length < 2;
    }
    function showMedia(mediaId) { const g = $(`.gal-i[data-media-id="${mediaId}"]`, wrap); if (g) showIndex(Number(g.dataset.galI)); }
    wrap.addEventListener("click", e => { const b = e.target.closest("[data-gal]"); if (b) showIndex(Number(b.dataset.gal)); });

    if (grouped) applyGroup(sel.variant || null);

    /* inputs in main box or sheet */
    document.addEventListener("change", e => {
      const root = e.target.closest(`[data-buy-root="${sid}"]`); if (!root) return;
      const t = e.target;
      if (t.matches("[data-opt]")) { sel.opts[Number(t.dataset.opt) - 1] = t.type === "checkbox" && !t.checked ? t.dataset.no : t.value; setVariantFromOpts(true); }
      else if (t.matches("[data-up]")) { sel.up = t.checked; sync(); }
      else if (t.matches("[data-pair]")) { t.checked ? sel.pairs.add(t.value) : sel.pairs.delete(t.value); sync(); }
    });
    document.addEventListener("click", e => {
      const q = e.target.closest(`[data-buy-root="${sid}"] [data-q]`);
      if (q) { sel.qty = Math.max(1, Math.min(99, sel.qty + Number(q.dataset.q))); sync(); return; }
      const atc = e.target.closest(`[data-buy-root="${sid}"] [data-atc], #sticky [data-atc]`);
      if (atc) { e.preventDefault(); add(); return; }
      const sh = e.target.closest("#sticky [data-sheet]");
      if (sh) { e.preventDefault(); openSheet(); }
    });
    form.tagName === "FORM" && form.addEventListener("submit", e => { e.preventDefault(); add(); });

    let busy = false;
    async function add() {
      if (busy || !available()) return;
      busy = true;
      const items = [{ id: sel.variant.id, quantity: sel.qty }];
      const u = upEl(mainRoot);
      if (sel.up && u) items.push({ id: Number(u.value), quantity: sel.qty });
      sel.pairs.forEach(id => items.push({ id: Number(id), quantity: 1 }));
      $$("[data-atc]").forEach(b => (b.disabled = true));
      try {
        await PT.cart.add(items);
        sel.pairs.clear(); sel.qty = 1; sel.up = false;
        if (PT.currentLayer && PT.currentLayer() && PT.currentLayer().id === "sheet") PT.closeLayer(true);
      } catch (_) {}
      busy = false; sync();
    }

    /* options sheet (phones): a copy of the buy box, kept in sync through sel */
    function openSheet() {
      const tpl = mainRoot.cloneNode(true);
      tpl.querySelectorAll("[name]").forEach(i => i.setAttribute("name", i.getAttribute("name").replace(/^m-/, "s-")));
      tpl.querySelectorAll("[id]").forEach(i => i.removeAttribute("id"));
      tpl.querySelectorAll('[type="submit"]').forEach(b => b.setAttribute("type", "button"));
      const img = wrap.dataset.img;
      PT.openLayer({
        kind: "sheet", id: "sheet", label: `${wrap.dataset.title} options`,
        head: `${img ? `<span class="th"><img src="${esc(img)}" alt=""></span>` : ""}<span><b>${esc(wrap.dataset.title)}</b><small><span data-unit>${sel.variant ? money(sel.variant.price) : ""}</span> · ${esc(wrap.dataset.sub || "")}</small></span>`,
        body: `<div id="s-buy" class="stack">${tpl.outerHTML}</div>`,
        onClose: () => sync()
      });
      sync();
      const first = document.querySelector("#s-buy input, #s-buy button"); first && first.focus();
    }

    /* sticky bar */
    if (mode !== "off") {
      const anchor = $("[data-atc]", mainRoot);
      const st = document.getElementById("sticky");
      if (st && anchor) {
        st.classList.toggle("min", mode === "min");
        PT.sticky.watch(anchor, () => {
          const img = wrap.dataset.img, tot = money(total());
          const btn = !available() ? `<span class="tag">Sold out</span>` : mode === "min"
            ? `<button type="button" class="btn btn-primary" data-sheet data-focus-key="b">Add to cart · ${tot}</button>`
            : `<button type="button" class="btn btn-primary" data-atc data-focus-key="b">Add · ${tot}</button>`;
          return `<div class="sticky-in">${img ? `<span class="th"><img src="${esc(img)}" alt=""></span>` : ""}<button type="button" class="sticky-x" data-sheet data-focus-key="x" aria-haspopup="dialog"><span style="min-width:0"><b>${esc(wrap.dataset.title)}</b><small>${esc(desc())}</small></span><span class="chev" aria-hidden="true">${CHEV_UP}</span><span class="sr-only">Change options</span></button>${btn}</div>`;
        });
      }
    }

    /* pairs fallback: Shopify complementary products when custom.pairs_with is empty */
    const box = $("[data-pairs-fetch]", mainRoot);
    if (box) {
      fetch(`${(PT.routes && PT.routes.root) || "/"}recommendations/products.json?product_id=${box.dataset.pairsFetch}&limit=3&intent=complementary`)
        .then(r => (r.ok ? r.json() : { products: [] }))
        .then(d => {
          const list = $("[data-pairs-list]", box);
          const ps = (d.products || []).filter(p => p.available && p.id !== product.id).slice(0, 3);
          if (!ps.length || !list) return;
          list.innerHTML = ps.map(p => {
            const v = p.variants.find(x => x.available) || p.variants[0];
            const imgUrl = p.featured_image ? (p.featured_image.includes("?") ? p.featured_image + "&width=120" : p.featured_image + "?width=120") : "";
            return `<label class="opt chk"><input type="checkbox" value="${v.id}" data-pair data-price="${v.price}" data-title="${esc(p.title)}"><span><span class="th">${imgUrl ? `<img src="${esc(imgUrl)}" alt="" width="52" height="52" loading="lazy">` : ""}</span><span>${esc(p.title)}${p.type ? `<small>${esc(p.type)}</small>` : ""}</span><span class="row" style="gap:10px"><span class="p">${money(v.price)}</span><span class="box" aria-hidden="true">${CHECK}</span></span></span></label>`;
          }).join("");
          box.hidden = false;
        }).catch(() => {});
    }

    sync();
  }

  function boot() { document.querySelectorAll("[data-pdp]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
